import { Table } from '../../Components/table.jsx';
import { router } from '@inertiajs/react';

export default function AccountActivationRequestsPage({ requests }) {
    
    const updateAccountState = (userId, action) => {
        router.put(`/admin/accounts/activation/${userId}`, { action });
    };

    const AccountActions = (_, { user }) => (
        <div className="flex gap-2">
            <button 
                className="text-sm font-medium text-sky-600 hover:text-sky-500" 
                onClick={() => updateAccountState(user.id, 'accept')}
            >
                Activate
            </button>
            <button 
                className="text-sm font-medium text-red-600 hover:text-red-500" 
                onClick={() => updateAccountState(user.id, 'decline')}
            >
                Reject
            </button>
        </div>
    );

    const StateTags = ( state ) => {
        console.log('State:', state);

        const stateClasses = {
            'requested': 'bg-yellow-100 text-yellow-800',
            'approved': 'bg-green-100 text-green-800',
            'rejected': 'bg-red-100 text-red-800',
            'suspended': 'bg-purple-100 text-purple-800',
        };

        return (
            <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-sm ${stateClasses[state] || 'bg-gray-100 text-gray-800'}`}>
                {state.charAt(0).toUpperCase() + state.slice(1)}
            </span>
        );
    };

    const columns = [
        { key: 'id', label: 'ID', sortable: true, width: 'w-1/12' },
        { key: 'user.name', label: 'User', sortable: true, width: 'w-1/6', repr: (_, row) => row.user.name },
        { key: 'user.email', label: 'Email', sortable: true, width: 'w-1/4', repr: (_, row) => row.user.email },
        { key: 'created_at', label: 'Requested At', sortable: true, width: 'w-1/4' },
        { key: 'state', label: 'State', sortable: true, width: 'w-1/12', repr: (_, row) => row.user.account_activation.state, display: StateTags},
        { key: 'actions', label: 'Actions', sortable: false, width: 'w-1/6', display: AccountActions },
    ];

    return (
        <div className="flex flex-col items-center justify-center flex-grow gap-4">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                Account Activation Requests
            </h1>

            <Table
                name="accountActivationRequests"
                columns={columns}
                rows={requests}
                emptyMessage="No pending activation requests."
            />

        </div>
    );
}
